module.exports = __webpack_public_path__ + "static/portfolio-image.eb514655.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio-image.png
// module id = 369
// module chunks = 35783957827783